import { render } from "./homeArticles.vue?vue&type=template&id=78703590&scoped=true&lang=html"
import script from "./homeArticles.vue?vue&type=script&lang=js"
export * from "./homeArticles.vue?vue&type=script&lang=js"

import "./homeArticles.vue?vue&type=style&index=0&id=78703590&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78703590"]])

export default __exports__